import { Col, Row, Typography } from "antd";
import React from "react";
import "../../components/css/Knives.css";
import KnivesSearch from "../../components/Knives/KnivesSearch";

const { Title } = Typography;

export default function Knives() {
   return (
      <div className="container-knives">
         <Row justify="center">
            <Col style={{ textAlign: "center" }} span={24}>
               <Title level={1}>Knives Management</Title>
            </Col>
         </Row>
         <Row justify="center">
            <Col span={24}>
               <KnivesSearch />
            </Col>
         </Row>
      </div>
   );
}
